module.exports = __webpack_public_path__ + "img/Universität_Graz_logo.svg.b728439a.png";